/**
 * YACHT® Guest Wishlist System (localStorage based)
 */

class YachtWishlist {
  constructor() {
    this.storageKey = 'yacht_guest_wishlist';
    this.wishlist = this.getWishlist();
    this.init();
  }

  getWishlist() {
    try {
      const items = localStorage.getItem(this.storageKey);
      return items ? JSON.parse(items) : [];
    } catch (e) {
      return [];
    }
  }

  saveWishlist() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.wishlist));
    } catch (e) {
      console.error('Could not save wishlist', e);
    }
  }

  init() {
    this.updateButtonsState();
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (btn) {
        e.preventDefault();
        const handle = btn.getAttribute('data-product-handle');
        if (handle) {
          this.toggleItem(handle, btn);
        }
      }
    });
  }

  toggleItem(handle, btn) {
    const index = this.wishlist.indexOf(handle);
    if (index > -1) {
      this.wishlist.splice(index, 1);
      btn.classList.remove('is-active');
      btn.setAttribute('aria-label', 'Add to Wishlist');
    } else {
      this.wishlist.push(handle);
      btn.classList.add('is-active');
      btn.setAttribute('aria-label', 'Remove from Wishlist');
    }
    this.saveWishlist();
  }

  updateButtonsState() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      if (this.wishlist.includes(handle)) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Remove from Wishlist');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-label', 'Add to Wishlist');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.yachtWishlist = new YachtWishlist();
});
